<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
      <b-avatar
        :variant="state.variant || 'primary'"
        size="1.8rem"
        class="mr-75 flex-shrink-0"
      >
        <feather-icon
          :icon="state.icon || 'RefreshCwIcon'"
          size="15"
        />
      </b-avatar>
      <div class="flex-grow-1">
        <h5
          v-if="state.title"
          class="mb-0 font-weight-bolder toastification-title"
          :class="`text-${state.variant || 'primary'}`"
          v-text="state.title"
        />
        <small
          v-if="state.text"
          class="d-inline-block text-body"
          v-text="state.text"
        />
        <b-progress
          :max="100"
          height="0.5rem"
          class="mt-50"
          :striped="state.progress === null"
          :animated="state.progress === null"
        >
          <b-progress-bar
            :value="state.progress === null ? 100 : state.progress"
            :variant="state.variant || 'primary'"
          />
        </b-progress>
        <small
          v-if="state.progress !== null"
          class="text-muted"
          v-text="`${state.progress}%`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar, BProgress, BProgressBar } from "bootstrap-vue";

export default {
  name: "BulkEditProgressToast",
  components: {
    BAvatar,
    BProgress,
    BProgressBar,
  },
  props: {
    // Reactive object so the toast re-renders on each poll update:
    // { title, text, progress (0-100 | null = indeterminate), variant, icon }
    state: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.toastification-title {
  line-height: 26px;
  color: inherit;
}
</style>
